/*
 * Copyright (c) 2026 Bluemate B.V.
 */

import {ResponseData} from '@dvrd/dvr-controls';
import User from '../models/userModel';
import {updateUser} from '../util/requestSender';
import i18n from './index';
import {AppLanguage, normalizeLanguage, UI_LANGUAGE_FLEX_KEY} from './config';

export function getCurrentLanguage(): AppLanguage {
    return normalizeLanguage(i18n.resolvedLanguage ?? i18n.language);
}

export function getLanguageFromUser(user: User | null | undefined): AppLanguage | null {
    const language = user?.getFlex(UI_LANGUAGE_FLEX_KEY);
    if (typeof language !== 'string' || !language.length) return null;
    return normalizeLanguage(language);
}

export async function setUserLanguage(user: User | null | undefined, normalized: AppLanguage): Promise<AppLanguage> {
    if (!user) return normalized;
    const previousLanguage = user.getFlex(UI_LANGUAGE_FLEX_KEY);

    const nextFlex = {...user.flex, [UI_LANGUAGE_FLEX_KEY]: normalized};
    user.setFlex(UI_LANGUAGE_FLEX_KEY, normalized);

    const revert = () => {
        if (previousLanguage === null || previousLanguage === undefined) {
            const revertedFlex = {...user.flex};
            delete revertedFlex[UI_LANGUAGE_FLEX_KEY];
            user.flex = revertedFlex;
        } else {
            user.setFlex(UI_LANGUAGE_FLEX_KEY, previousLanguage);
        }
    };

    try {
        updateUser({
            data: {flex: nextFlex},
            callback: (data: ResponseData) => {
                if (!data.success) revert();
            }
        });
    } catch (err) {
        revert();
        console.error('[i18n] Failed to persist user language', err);
    }
    return normalized;
}
